import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
//import {ProductComponent} from "../features/components/product/product.component";



@NgModule({
  declarations: [
    //ProductComponent
  ],
  imports: [
    CommonModule
  ]
})
export class CoreModule { }
